/* global axios */
import ApiClient from './ApiClient';

class ConversationStagesApi extends ApiClient {
  constructor() {
    super('conversation_stages', { accountScoped: true });
  }

  reorder(conversationStageIds) {
    return axios.post(`${this.url}/reorder`, {
      conversation_stage_ids: conversationStageIds,
    });
  }
}

export default new ConversationStagesApi();
